import ManageGrossesse from '@/views/consultations/en-cours/grossesse/manage-grossesse'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'grossesse',
    components: {
        ManageGrossesse
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_patient: {},
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_grossesse: [],
            selected_grossesse: [],
            data_to_be_deleted: {},
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()

            this.userInfoSetter()
        }
    },

    computed: {
        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        patient() {
            return this.$store.getters['patient'];
        },
    },

    mounted() {
        this.userInfoSetter()
        this.getData()
    },

    methods: {
        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'M':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age
            }

            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        addNew() {
            this.group_id = 0
            this.selected_grossesse = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#grs-'+this.evolution_id).modal('show')
        },

        getData() {
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: 'grossesse',
                est_en_cours: true
            }

            return store_fiche.getCustomConsultationSectionData(data).then((response) => {
                this.list_grossesse = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
            }).catch(() => {
                this.is_empty = true
            }).finally(() => {
                this.is_loading = false
            })
        },

        editGrs(data) {
            this.group_id = data.group_service_id
            this.selected_grossesse = data.fields

            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#grs-'+this.evolution_id).modal('show')
        },

        removeGrossesse(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: 'grossesse'
            }

            $('.del-grp-grs'+this.evolution_id).modal('show')
        }
    }
}
